import { APP_STATUS } from "./action-types";

export const appStatusReducer = (state = { status: '' }, action) => {
  switch (action.type) {

    case APP_STATUS:
      return { status: action.status };

    default:
      return state;
  }
};
